import { http } from '@/core/helpers/http.helper';
import { PublishPosition } from './publish.interface';

export class PublishService {
   async publish(positionId: number, publishData: PublishPosition) {
      const response = await http.post(`/positions/${positionId}/publish`, publishData);
      return response.data;
   }
}
